module.exports = __webpack_public_path__ + "assets/images/chart.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/chart.png
// module id = 2317
// module chunks = 0